import { PUBLIC_HOSTS } from '../constant'
import type { HOSTKEY } from '../constant'
import { getHost, getKdocsPath, getOrigin } from './hostUtil'

/**
 * Reactive to double bind object
 * @param {*} obj need to be binded
 * @returns Proxy object
 */
const reactive = (obj: object) =>
  new Proxy(obj, {
    get (target, key, receiver) {
      const ret = Reflect.get(target, key, receiver)
      return ret === Object(ret) ? reactive(ret) : ret
    },
    set (target, key, val, receiver) {
      const ret = Reflect.set(target, key, val, receiver)
      return ret
    },
    deleteProperty (target, key) {
      const ret = Reflect.deleteProperty(target, key)
      return ret
    },
  })

/**
 * 判断是否是IE浏览器，如果是，则不支持proxy
 * @returns
 */
const canUseProxy = () => typeof Proxy === 'function'

/**
 * 是否是私有化场景
 */
const isPrivate = () => {
  return (typeof window !== 'undefined' && (window as any).__KD_CONFIG__) ||
  (typeof global !== 'undefined' && global.__KD_CONFIG__)
}
/**
 * 当应用使用kso或plusui时，自定义域名时，需要全局替换window.__HOSTS__
 * window.__HOSTS__: {ACCOUNT: 'account_test.wps.cn'}
 * hosthooks会在初始化时，进行覆盖
 */
const globalHosts = () =>
  (typeof window !== 'undefined' && (window as any).__HOSTS__) ||
  (typeof global !== 'undefined' && global.__HOSTS__) ||
  {}
/**
 * Hooks to get host and its changed method
 * @param {*} isHttp
 * @param {*} override new hosts to override origin hosts
 * @returns hooks provides hosts and method
 */
/**
 * Hooks to get host and its changed method
 * @param {*} _config
 *  - override       new hosts to override origin hosts
 *  - alwaysHttps         if true, will return https:// without ssl
 * @returns
 */
const hostHooks = (_config = { 
  alwaysHttps: false, 
  override: {}, 
  ctx: null,
}) => {
  const { alwaysHttps = false, override = {}, ctx = null } = _config
  const hosts = canUseProxy() ? reactive({}) : {}
  const protocol = 'https'
  const action = {
    /**
     * 更新hosts
     * @param {*} _hosts
     */
    setHosts: (_hosts) => {
      for (const key in _hosts) {
        const host = alwaysHttps
          ? `${protocol}://${getHost(key as HOSTKEY, (ctx as any))}`
          : getOrigin(key as HOSTKEY, (ctx as any))
        hosts[key] = isPrivate() ? host : _hosts[key]
      }
    },
    /**
     * 替换如下场景的url
     * -    window.open
     * -    location.href
     * -    window.top.location.href
     * @param {*} url
     * @returns
     */
    replaceOpenHref: (url = '') => {
      if (isPrivate()) {
        let addresses = {}
        if (typeof window !== 'undefined' && (window as any).__KD_CONFIG__) {
          addresses = (window as any).__KD_CONFIG__.addresses || {}
        }
        // 不在address中记录的path，都认为是kdocs下的路径
        const isKdocsPage = Object.values(addresses).every((item: any) => (url.indexOf(item.path) === -1))
        return isKdocsPage ? `${getKdocsPath()}${url}` : url
      } else {
        return url
      }
    },
    /**
     * 替换location.host
     * @param {*} path
     * @returns
     */
    replaceLocHost: (path = '') => {
      if (typeof window !== 'undefined') {
        if (isPrivate()) {
          return `${window.location.protocol}//${window.location.host + getKdocsPath() + path}`
        } else  {
          return `${window.location.protocol}//${window.location.host + path}`
        }
      } else {
        return path
      }
    },
  }
  /** 
   * todo: ... spread操作符 打包之后在项目引入报错 Object(...) is not a function，后期需要处理
   * const mergedHosts = { ...PUBLIC_HOSTS, ...globalHosts(), ...override }
   */
  const mergedHosts = Object.assign({}, PUBLIC_HOSTS, globalHosts(), override)
  action.setHosts(mergedHosts)
  return [hosts, action]
}
/**
     * 替换如下场景的url
     * -    window.open
     * -    location.href
     * -    window.top.location.href
     * @param {*} url
     * @returns
     */
const replaceOpenHref = (url = '') => {
  if (isPrivate()) {
    let addresses = {}
    if (typeof window !== 'undefined' && (window as any).__KD_CONFIG__) {
      addresses = (window as any).__KD_CONFIG__.addresses || {}
    }
    // 不在address中记录的path，都认为是kdocs下的路径
    const isKdocsPage = Object.values(addresses).every((item: any) => (url.indexOf(item.path) === -1))
    return isKdocsPage ? `${getKdocsPath()}${url}` : url
  } else {
    return url
  }
}
/**
 * 替换location.host
 * @param {*} path
 * @returns
 */
const replaceLocHost = (path = '') => {
  if (typeof window !== 'undefined') {
    if (isPrivate()) {
      return `${window.location.protocol}//${window.location.host + getKdocsPath() + path}`
    } else  {
      return `${window.location.protocol}//${window.location.host + path}`
    }
  } else {
    return path
  }
}
export {
  hostHooks,
  isPrivate,
  replaceOpenHref,
  replaceLocHost,
}
